export default __webpack_public_path__ + "static/media/mykulychyn_gerb.c800661b.png";